var React = require('react');

function Pin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M50 10.784c-15.705 0-28.5 12.641-28.5 28.219 0 7.95 4.053 16.805 9.375 25.5s12.015 17.204 17.594 24a2 2 0 003.062 0c5.58-6.796 12.272-15.305 17.594-24 5.322-8.695 9.375-17.55 9.375-25.5 0-15.578-12.795-28.219-28.5-28.219zm0 4c13.566 0 24.5 10.825 24.5 24.219 0 6.534-3.632 14.994-8.781 23.406C61.018 70.089 55.2 77.63 50 84.034c-5.2-6.404-11.018-13.945-15.719-21.625-5.15-8.412-8.781-16.872-8.781-23.406 0-13.394 10.934-24.219 24.5-24.219zm0 9.531c-8.124 0-14.75 6.682-14.75 14.875 0 8.194 6.626 14.875 14.75 14.875 8.124 0 14.75-6.681 14.75-14.875 0-8.193-6.626-14.875-14.75-14.875zm0 4.031c5.971 0 10.781 4.822 10.781 10.844 0 6.023-4.81 10.875-10.781 10.875-5.971 0-10.781-4.852-10.781-10.875 0-6.022 4.81-10.844 10.781-10.844z"}));
}

Pin.defaultProps = {"height":"100","width":"100","viewBox":"0 0 100 100"};

module.exports = Pin;

Pin.default = Pin;
